// extracted by mini-css-extract-plugin
export var content = "ProfileCard-module--content--M4yt4";
export var arrow = "ProfileCard-module--arrow--1zQ_N";
export var none = "ProfileCard-module--none--177vz";
export var white = "ProfileCard-module--white--1civ9";
export var grey = "ProfileCard-module--grey--1IvkT";
export var pink = "ProfileCard-module--pink--2zxbJ";
export var sparkCard = "ProfileCard-module--spark-card--2_0hq";
export var links = "ProfileCard-module--links--24yws";
export var divider = "ProfileCard-module--divider--v0DnT";